import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {
  Action,
  Category,
  Entity,
  Page,
  Team
} from '@vio/core/src/analytics/types/Events'

import {DEAL_FREEZE_EDUCATION_BANNER_COMPONENT} from './constants'

import type {DealFreezeEducationBannerPlacement} from './constants'

interface TrackArgs {
  placement: DealFreezeEducationBannerPlacement
}

export const trackDealFreezeEducationBannerDisplayed = ({
  placement
}: TrackArgs) =>
  trackEvent({
    category: Category.System,
    entity: Entity.DealFreezeEducationBanner,
    action: Action.Displayed,
    team: Team.Retention,
    page: Page.Search,
    component: DEAL_FREEZE_EDUCATION_BANNER_COMPONENT,
    payload: {placement}
  })

export const trackDealFreezeEducationBannerDismissed = ({
  placement
}: TrackArgs) =>
  trackEvent({
    category: Category.User,
    entity: Entity.DealFreezeEducationBanner,
    action: Action.Closed,
    team: Team.Retention,
    page: Page.Search,
    component: DEAL_FREEZE_EDUCATION_BANNER_COMPONENT,
    payload: {placement}
  })

export const trackDealFreezeEducationBannerCtaClicked = ({
  placement
}: TrackArgs) =>
  trackEvent({
    category: Category.User,
    entity: Entity.DealFreezeEducationBanner,
    action: Action.Clicked,
    team: Team.Retention,
    page: Page.Search,
    component: DEAL_FREEZE_EDUCATION_BANNER_COMPONENT,
    payload: {placement}
  })
